module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Adicionar arquivo'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-file-input', {
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "uploadFileInput",
      "label": "Clique aqui para selecionar o arquivo",
      "outlined": "",
      "truncate-length": "220",
      "chips": "",
      "show-size": "",
      "accept": "application/pdf",
      "hint": "O arquivo deve estar no formato PDF e pode ter no máximo 5 MB.",
      "persistent-hint": "",
      "rules": _vm.obrigatorio
    },
    on: {
      "change": _vm.selecionaArquivo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "tipoArquivo",
      "label": "Tipo do arquivo*",
      "items": _vm.listaTipoArquivo,
      "item-text": "descricao",
      "item-value": "item",
      "prepend-icon": "dashboard",
      "return-object": "",
      "autocomplete": "",
      "required": "",
      "rules": _vm.obrigatorio
    },
    model: {
      value: (_vm.arquivo.tipoArquivo),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "tipoArquivo", $$v)
      },
      expression: "arquivo.tipoArquivo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "observacao",
    attrs: {
      "label": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? 'Observação*' : 'Observação' : 'Observação',
      "rules": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? _vm.obrigatorio.concat( _vm.max200caracteres) : _vm.max200caracteres : _vm.max200caracteres,
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "200",
      "hint": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? 'Informe o tipo de documento' : false : false,
      "persistent-hint": _vm.arquivo.tipoArquivo !== null ? _vm.arquivo.tipoArquivo.item === 3 ? true : false : false
    },
    model: {
      value: (_vm.arquivo.observacao),
      callback: function($$v) {
        _vm.$set(_vm.arquivo, "observacao", $$v)
      },
      expression: "arquivo.observacao"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.adicionarArquivo()
      }
    }
  }, [_vm._v("Adicionar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e291a74a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/adicionar-arquivo.vue
// module id = 875
// module chunks = 0